import { useQuery } from '@tanstack/react-query'

import { billingApi } from '@/lib/api/billing'

/**
 * The account's credit movements, newest first.
 *
 * Its own hook rather than part of `useCredits` because the balance is read on every page
 * (it sits in the bar) and the history is read on one. Fetching a ledger to render a number
 * would make every navigation more expensive than it needs to be.
 */
export function useCreditHistory(limit = 20) {
  return useQuery({
    queryKey: ['billing', 'credits', 'history', limit],
    queryFn: () => billingApi.transactions(limit),
    staleTime: 30_000,
    retry: false,
  })
}
